import { API } from "aws-amplify";
import { processConfig as process } from "../../config/env";

const ORDER_API_NAME = process.env.BACK_API_NAME_V2;

export function getOrderDetail({ user_id, order_id }) {
  return API.get(
    ORDER_API_NAME,
    `/order-bff/users/${user_id}/orders/${order_id}`
  );
}
